// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1D1v0","inputWrap":"CustomTip_inputWrap__IwE7y"};